import React, {useEffect} from 'react';
import {Outlet, useLocation, matchPath} from 'react-router-dom';
import {ROUTES} from '@contentlab/config/routesConstants';
import useOnboardingFlags from '@contentlab/hooks/use-onboarding-flags/useOnboardingFlags';
import {contentLabActions} from '@contentlab/stores/contentLabStore';
import {
  getContentLabOnboardingTargetFeature,
  setContentLabOnboardingTargetFeature,
} from '@/utils/LtidStorage';
import useNavigation from '@/hooks/use-navigation';

/**
 * A route guard component that checks if the user has completed Content Studio onboarding.
 * If onboarding is not completed, it redirects to the onboarding page.
 * Otherwise, it renders the outlet for nested routes.
 */
function ContentLabOnboardingGuard() {
  const location = useLocation();
  const {hasCompletedCurrentOnboardingVersion, isFetching} =
    useOnboardingFlags();
  const onboardingTargetFeature = getContentLabOnboardingTargetFeature();
  const {navigate} = useNavigation();

  const ONBOARDING_ROUTES = [
    ROUTES.CONTENT_LAB_ONBOARDING,
    ROUTES.CONTENT_LAB_PRICING,
  ];

  useEffect(() => {
    const isAllowedOnboardingRoute = ONBOARDING_ROUTES.some((route) =>
      Boolean(
        matchPath({path: `${ROUTES.CONTENT_LAB}${route}`}, location.pathname)
      )
    );

    if (!isAllowedOnboardingRoute) {
      if (!isFetching && !hasCompletedCurrentOnboardingVersion) {
        navigate(`${ROUTES.CONTENT_LAB}${ROUTES.CONTENT_LAB_ONBOARDING}`, {
          replace: true,
        });
      } else if (onboardingTargetFeature) {
        contentLabActions.setIsOnboardingModalOpen(true);
        contentLabActions.setOnboardingTargetFeature(onboardingTargetFeature);
        setContentLabOnboardingTargetFeature(null);
      }
    }
  }, [isFetching, location.pathname, hasCompletedCurrentOnboardingVersion]);

  return <Outlet />;
}

export default ContentLabOnboardingGuard;
